<template>
  <div class="filter-inputs-summary">
    <p
      class="form-control-static filter-inputs-summary__tag-id clickable"
      @click="enableEditView()"
    >
      {{ criteria.tagId | tagIdToText(availableTags) }}
    </p>

    <p
      class="form-control-static filter-inputs-summary__comparison clickable"
      @click="enableEditView()"
    >
      {{ criteria.comparisonTypeTemp.value | camelCaseFormat }}
    </p>

    <div
      v-if="isArray(criteria.value)"
      class="form-control-static filter-inputs-summary__value states-summary"
      @click="enableEditView()"
    >
      <strong
        v-for="(state, index) in sort(criteria.value)"
        :key="state"
        class="clickable"
      >
        {{ getStateValue(criteria.tagId, state) }}
        <span
          v-if="index == items.length - 1"
          class="text-muted divider"
        >|</span>
      </strong>
    </div>

    <div
      v-if="!isArray(criteria.value)"
      class="form-control-static filter-inputs-summary__value filter-inputs-summary__value--selected clickable"
      @click="enableEditView()"
    >
      <i
        v-if="criteria.isBulkTag && criteria.hasMultipleValues"
        v-t="'BULK_TAGS_TEXT'"
      >:</i>

      <strong>{{ criteria.value }}</strong>
    </div>

    <a
      v-if="!isReadOnly"
      class="btn btn-function filter-item-edit"
      @click="enableEditView()"
    >
      <i class="typcn typcn-edit" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'OrCriteriaSummary',
  props: {
    criteria: {
      type: Object,
      default() {
        return {};
      }
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    availableTags: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    enableEditView() {
      this.$emit('edit');
    },
    isArray(value) {
      return Array.isArray(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-inputs-summary {
  display: flex;
  position: relative;
  font-size: 1.3em;

  .states-summary {
    display: flex;
    flex-wrap: wrap;
    color: var(--component-ivr-router-filter__states-summary-font-color);
    > strong {
      margin-right: 10px;

      .divider {
        margin-left: 6px;
      }
    }
  }
}

.filter-item-edit {
  position: absolute;
  top: 10px;
  right: -30px;
}

.filter-inputs-summary__tag-id {
  flex: 0 0 47%;
}

.filter-inputs-summary__comparison {
  flex: 0 0 19%;
  min-width: 19%;
  margin: 0 15px;
}

.filter-inputs-summary__value {
  flex: 0 0 30%;
}

.filter-inputs-summary__value--selected {
  @include text-overflow();
  color: var(--component-ivr-router-filter__filter-value--selected-font-color);
}
</style>